"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('models/userIdentityModel',["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";

    var UserIdentityModel = function () {
        function UserIdentityModel() {
            _classCallCheck(this, UserIdentityModel);

            this.userName = ko.observable('');
            this.requiresTwoFactor = ko.observable(false);
            this.twoFactorEnabled = ko.observable(false);
            this.useRecoveryCode = ko.observable(false);
            this.qrCodeSetupImageUrl = ko.observable('');
            this.manualEntryKey = ko.observable('');
            this.recoveryCodes = ko.observableArray([]);
            this.isAuthenticated = ko.observable(false);
            this.claims = ko.observableArray([]);
            this.hasClaims = ko.pureComputed(this.computeHasClaims, this);
            this.sessionId = ko.observable('');
            this.insurerId = ko.observable(0);
            this.localLoginProvider = ko.observable('');
        }

        _createClass(UserIdentityModel, [{
            key: "setUserName",
            value: function setUserName(username) {
                this.userName(username);
            }
        }, {
            key: "setSessionId",
            value: function setSessionId(sessionId) {
                this.sessionId(sessionId);
            }
        }, {
            key: "setLocalLoginProvider",
            value: function setLocalLoginProvider(localLoginProvider) {
                this.localLoginProvider(localLoginProvider);
            }
        }, {
            key: "setTwoFactorEnabled",
            value: function setTwoFactorEnabled(twoFactorEnabled) {
                this.twoFactorEnabled(twoFactorEnabled);
            }
        }, {
            key: "setInsurerId",
            value: function setInsurerId() {
                if (this.hasClaim("visible-data", "ageas")) {
                    this.insurerId(1);
                }
                if (this.hasClaim("visible-data", "ers")) {
                    this.insurerId(2);
                }
                if (this.hasClaim("visible-data", "markerstudy")) {
                    this.insurerId(3);
                }
                if (this.hasClaim("visible-data", "kgm")) {
                    this.insurerId(4);
                }
                if (this.hasClaim("visible-data", "qudos")) {
                    this.insurerId(5);
                }
                if (this.hasClaim("visible-data", "highway")) {
                    this.insurerId(6);
                }
                if (this.hasClaim("visible-data", "aviva")) {
                    this.insurerId(7);
                }
                if (this.hasClaim("visible-data", "trinity")) {
                    this.insurerId(8);
                }
                if (this.hasClaim("visible-data", "axa")) {
                    this.insurerId(9);
                }
            }
        }, {
            key: "hasClaim",
            value: function hasClaim(claimType, claimValue) {
                var result = false;
                if (this.claims().length > 0) {
                    $.each(this.claims(), function (i, claim) {
                        if (claim.claimType === claimType && claim.claimValue === claimValue) {
                            result = true;
                        }
                    });
                }
                return result;
            }
        }, {
            key: "getClaimValue",
            value: function getClaimValue(claimType) {
                var result = '';
                if (this.claims().length > 0) {
                    $.each(this.claims(), function (i, claim) {
                        if (claim.claimType === claimType) {
                            result = claim.claimValue;
                        }
                    });
                }
                return result;
            }
        }, {
            key: "clear",
            value: function clear() {
                this.isAuthenticated(false);
                this.claims.removeAll();
                this.userName('');
            }
        }, {
            key: "computeHasClaims",
            value: function computeHasClaims() {
                var claims = this.claims();
                return claims.length > 0;
            }
        }]);

        return UserIdentityModel;
    }();

    return new UserIdentityModel();
});
//# sourceMappingURL=userIdentityModel.js.map;
